module.exports = __webpack_public_path__ + "static/Statistics-354a1fadd74b0a5246ca7107748c78b9.png";